module.exports = {
  Auth: {
    identityPoolId: 'ap-northeast-1:6f6fd8e8-2b76-4c54-a9cf-528e2f3b878d',
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_Cd8ZhbeRW',
    userPoolWebClientId: '6s5d0sons123uhcp96o2uo4jv6',
    mandatorySignIn: false,
  },
  API: {
    endpoints: [
      {
        name: 'dev',
        endpoint: 'https://api.senrigan-hihakai.com/dev'
      },
      {
        name: 'dev2',
        endpoint: 'https://api.senrigan-hihakai.com/dev2'
      },
      {
        name: 'test',
        endpoint: 'https://api.senrigan-hihakai.com/test'
      },
      {
        name: 'staging',
        endpoint: 'https://api.senrigan-hihakai.com/staging'
      },
      {
        name: 'prod',
        endpoint: 'https://api.senrigan-hihakai.com/prod'
      }
    ]
  },
  Storage: {
    bucket: 'document.senrigan.konicaminolta.com',
    region: 'ap-northeast-1'
  },
}
